var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 12C9.73896 12 11.25 10.489 11.25 8.625C11.25 6.76104 9.73896 5.25 7.875 5.25C6.01104 5.25 4.5 6.76104 4.5 8.625C4.5 10.489 6.01104 12 7.875 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 12C17.989 12 19.5 10.489 19.5 8.625C19.5 6.76104 17.989 5.25 16.125 5.25C14.261 5.25 12.75 6.76104 12.75 8.625C12.75 10.489 14.261 12 16.125 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
    fill: "#402A32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15.8284 10.5 16.5 9.82843 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5Z",
    fill: "#402A32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C9 14.8431 10.3431 13.5 12 13.5C13.6569 13.5 15 14.8431 15 16.5V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V16.5Z",
    fill: "#BB1D80"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurious);
export default __webpack_public_path__ + "static/media/curious.9e7880fd.svg";
export { ForwardRef as ReactComponent };